import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    currentPage: 1,
    pageSize: 20,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);


export default viewModel;
  

export {
    update,
    reset,
};
